import { BackednResponse } from "@shared/lib/types";
import { IGstInvoices, IGstInvoicesRequest } from "@shared/lib/types/finance";
import { useQuery } from "@tanstack/react-query";
import { FinanceApprovalService } from "../services/FinanceApprovalService";
import { GST_INVOICES_QUERY_KEY } from "../constants";

import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";

export function useGetGstInvoices(params: IGstInvoicesRequest) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IGstInvoices>
  >({
    queryKey: [...GST_INVOICES_QUERY_KEY, params],
    queryFn: () => FinanceApprovalService.getGstInvoices(params),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);
  return {
    invoices: data?.data?.data || [],
    gstAmountAggregate:
      data?.data?.data?.reduce((acc, curr) => acc + (curr.gstAmount || 0), 0) ||
      0,
    baseCostAggregate:
      data?.data?.data?.reduce((acc, curr) => acc + (curr.baseCost || 0), 0) ||
      0,
    isFetching: isLoading,
    isError,
  };
}
